import { DEFAULT_BOARD_COLUMN_COLOR } from '../../lib/boardColumn.constants'
import type { BoardEditBoardState, BoardEditSliceState } from './boardEdit.types'

export const createEmptyBoardEditBoardState = (): BoardEditBoardState => ({
  loading: false,
  loadError: null,
  board: null,
  boardTitle: '',
  savedBoardTitle: '',
  boardItems: [],
  columns: [],
  columnDrafts: {},
  savingBoardTitle: false,
  creatingColumn: false,
  savingColumnId: null,
  deletingColumnId: null,
  deletingSummaryId: null,
  reorderingLaneKey: null,
  reorderingPreviousBoardItems: null,
  deletingBoard: false,
  newColumnTitle: '',
  newColumnColor: DEFAULT_BOARD_COLUMN_COLOR,
})

export const createInitialBoardEditState = (): BoardEditSliceState => ({
  byBoardId: {},
})
